import React from 'react';
import FormRegister from '../components/authentication/FormRegister';

function Register() {
  return (
    <>
      <div className="register">
        <FormRegister />
        </div>
    </>
  );
}

export default Register;